import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const missionItems = [
    t('about.mission1'),
    t('about.mission2'),
    t('about.mission3'),
    t('about.mission4'),
  ];

  return (
    <section id="about" className="relative w-full py-20 md:py-32 bg-dark-900">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-dark-400 border border-white/5 mb-6">
              <span className="text-xs md:text-sm text-gray-400 font-medium">{t('about.badge')}</span>
            </div>

            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8">
              {t('about.title1')}
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
                {t('about.title2')}
              </span>
            </h2>

            <div className="space-y-6 text-sm md:text-base text-gray-400 leading-relaxed">
              <p>{t('about.p1')}</p>
              <p>{t('about.p2')}</p>
              <p>{t('about.p3')}</p>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="p-4 md:p-5 rounded-xl bg-dark-500 border border-white/5">
                <div className="text-2xl md:text-3xl font-display font-bold text-neon-blue mb-1">50+</div>
                <div className="text-xs md:text-sm text-gray-500">{t('about.projectsDelivered')}</div>
              </div>
              <div className="p-4 md:p-5 rounded-xl bg-dark-500 border border-white/5">
                <div className="text-2xl md:text-3xl font-display font-bold text-neon-purple mb-1">2+</div>
                <div className="text-xs md:text-sm text-gray-500">{t('about.yearsInBusiness')}</div>
              </div>
              <div className="p-4 md:p-5 rounded-xl bg-dark-500 border border-white/5">
                <div className="text-2xl md:text-3xl font-display font-bold text-neon-gold mb-1">10+</div>
                <div className="text-xs md:text-sm text-gray-500">{t('about.teamMembers')}</div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-md">
            <div className="relative p-6 md:p-8 rounded-3xl bg-gradient-to-br from-dark-500 to-dark-600 border border-white/5">
              <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-6">
                {t('about.quote')}
              </p>
              <div className="flex items-center gap-4">
                <img
                  src="https://storage.readdy-site.link/project_files/cda64c73-0cd6-4b91-8a57-da1fc108f4d8/c8da654f-8114-430e-9c9c-3079f9d57510_svgmaker-editor.svg?v=bda0da09cbc0c79cb977d66f891a46d3"
                  alt="Quaron Software"
                  className="w-12 h-12 rounded-full bg-gradient-to-br from-neon-blue/20 to-neon-purple/20 p-1.5 object-contain"
                />
                <div>
                  <div className="text-sm font-semibold text-white">{t('about.companyName')}</div>
                  <div className="text-xs text-gray-500">{t('about.companySubtitle')}</div>
                </div>
              </div>
            </div>

            <div className="mt-6 p-6 md:p-8 rounded-3xl bg-dark-500/50 border border-white/5">
              <h4 className="text-sm font-semibold text-white mb-4">{t('about.missionTitle')}</h4>
              <ul className="space-y-3">
                {missionItems.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-gray-400">
                    <span className="w-1.5 h-1.5 rounded-full bg-neon-blue" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
